<!--
 * @Author: 张韶杰
 * @Date: 2024-10-31 11:14:34
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2026-07-23 10:28:13
 * @FilePath: \ysz_web_international_h5\src\components\footer.vue
 * @Description: 
 * 
-->

<template>
  <div class="footer">
    <div class="footer_item">
      <div class="footer_title">FOLLOW US</div>
      <div class="social_icons">
        <img
          v-for="(item, index) in socialIcons"
          :key="index"
          class="social_icon"
          :src="item.icon"
          @click="handleSocialClick(item.href)"
          alt=""
        />
      </div>
    </div>

    <div class="footer_item">
      <div class="footer_title">CONTACT</div>
      <div class="contact_row">
        <span>Phone: +86 21 58545118</span>
        <span>Mail: yixuejie@yxj.org.cn</span>
      </div>
    </div>

    <div class="footer_item">
      <div class="footer_title">ADDRESS</div>
      <div class="address_text">
        Company Address: Floor 19, Tower A, Wanda Plaza, Wujiaochang, Yangpu District, Shanghai, China
      </div>
    </div>

    <div class="footer_item">
      <div class="footer_title">ABOUT</div>
      <div class="link_row">
        <span class="footer_link" @click="handleToPath('/about')">About MedJ</span>
        <span class="footer_link" @click="handleToPath('/privacy')">Privacy Policy</span>
        <span class="footer_link" @click="handleToPath('/terms')">Terms of Use</span>
      </div>
    </div>

    <div class="footer_item">
      <div class="footer_title">SERVICES</div>
      <div class="services_grid">
        <div
          class="services_col"
          v-for="(col, colIndex) in servicesList"
          :key="colIndex"
        >
          <div
            class="footer_link"
            v-for="item in col"
            :key="item.label"
            @click="handleServiceClick(item)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>

    <div class="footer_bottom">
      <img class="footer_logo" src="../assets/images/footer_logo.png" alt="MedJ" />
      <div class="copyright">
        Copyright © 2026 Shanghai Yimi Information Technology Co., Ltd. All rights reserved
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import footerIcon1 from '../assets/images/footer_icon_1.png'
import footerIcon2 from '../assets/images/footer_icon_2.png'
import footerIcon3 from '../assets/images/footer_icon_3.png'
import footerIcon4 from '../assets/images/footer_icon_4.png'

export default {
  data() {
    return {
      socialIcons: [
        {
          icon: footerIcon1,
          href: 'https://www.youtube.com/@MedJ-cn'
        },
        {
          icon: footerIcon2,
          href: 'https://x.com/MedJ0401'
        },
        {
          icon: footerIcon3,
          href: ''
        },
        {
          icon: footerIcon4,
          href: 'https://www.linkedin.com/company/medj/?viewAsMember=true'
        }
      ],
      servicesList: [
        [
          { label: 'Latest News', url: '/innovation_tracker_latest_news' },
          { label: 'Frontier Research', url: '/innovation_tracker_frontier_research' },
        ],
        [
          { label: 'Innovation Drugs', url: '/innovation_tracker' },
          { label: 'Conferences', url: '/conferences' },
        ],
        [
          { label: 'Doctors', url: '/doctors' },
          { label: 'Webinar', url: '/webinar' },
        ],
      ],
    }
  },
  methods: {
    ...mapActions({
      setAcchorName: 'setAcchorName'
    }),
    handleToPath(path) {
      if (this.$route.path === path) {
        window.scrollTo(0, 0);
        return
      }
      this.$router.push(path)
    },
    handleServiceClick(item) {
      this.$router.push(item.url)
      window.scrollTo(0, 0);
    },
    handleSocialClick(href) {
      if (href === '') {
        this.$router.push('/about_wechat')
        return
      }
      window.location.href = href
    }
  },
}
</script>

<style lang="scss" scoped>
.footer {
  padding: 16px;
  background-color: #211F1F;
  font-family: Manrope;
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  letter-spacing: 0.04em;
  color: #FFFFFF;

  .footer_item {
    margin-bottom: 24px;

    &:last-of-type {
      margin-bottom: 20px;
    }
  }

  .footer_title {
    margin-bottom: 10px;
    font-family: "Times New Roman", serif;
    font-size: 14px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0.04em;
    color: #FFFFFF;
  }

  .social_icons {
    display: flex;
    align-items: center;
    gap: 12px;

    .social_icon {
      width: 26px;
      height: 26px;
      display: block;
    }
  }

  .contact_row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 32px;
  }

  .address_text {
    max-width: 100%;
  }

  .link_row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .footer_link {
    cursor: pointer;
  }

  .services_grid {
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: space-start;
    .services_col {
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: max-content;
    }

    .footer_link {
      white-space: nowrap;
    }
  }

  .footer_bottom {
    padding-top: 16px;
   /* 描边色 */
    border-top: 1px solid #E2E2E2;
    display: flex;
    align-items: center;
    gap: 12px;

    .footer_logo {
      flex-shrink: 0;
      width: 41px;
      height: auto;
      display: block;
    }

    .copyright {
      flex: 1;
      font-size: 10px;
      line-height: 14px;
      color: rgba(255, 255, 255, 0.7);
    }
  }
}
</style>
